export default __webpack_public_path__ + "static/media/98_desktop.50845a8e.jpg";